import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import '@hox/frontend-utils/polyfills/getAttributeNames';
import '@hox/frontend-utils/polyfills/urlSearchParams';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { theme } from '@hox/ui/styles/theme';
import { GlobalStyles } from '@hox/ui/styles/GlobalStyles';
import { TranslationsProvider } from '@hox/frontend-utils/translations/TranslationsProvider';
import {
  isValidLocale,
  ELocale,
} from '@hox/frontend-utils/translations/locales';

import App from 'views/App';
import { config } from 'utils/config';

const getLocaleFromQueryParam = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const queryLocale = searchParams.get('locale');
  return isValidLocale(queryLocale) ? queryLocale : ELocale.EN;
};

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <TranslationsProvider
      baseUrl={config.i18nCdnUrl}
      locale={getLocaleFromQueryParam()}
      sources={['frontend.apps.auth']}
    >
      <GlobalStyles />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </TranslationsProvider>
  </ThemeProvider>,
  document.getElementById('root')
);
